// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3CJlK","colCheckbox":"styles_colCheckbox__oe-YJ"};